import { rModelsBase } from './.catalog';

export interface rEmlakVergiUstbilgiDetay_RawData {
    Anahtar: string;
    Taksit1: number;
    Taksit2: number;
    Toplam: number;
}

export default class rEmlakVergiUstbilgiDetay extends rModelsBase {
    constructor(
        options1?: {
            Data: rEmlakVergiUstbilgiDetay_RawData[] | undefined;
        },
        options2?: rEmlakVergiUstbilgiDetay | undefined
    ) {
        super();
        this.Data = (options1?.Data || options2?.Data || []);
    }

    public Data: rEmlakVergiUstbilgiDetay_RawData[];
}